export const quickTipsTypeConst = [
  { id: 1, name: 'Price question' },
  { id: 2, name: 'Quiz question' },
];
